import axios from "axios";

export class payment_type
{
    constructor(session) {
        this.user = session ? session.user : null;
        this.id_company = session ? session.id_company : null;
        this.id_branch = session ? session.id_branch : null;
        this.token = session ? session.token : null;
        this.id = null;
        this.name = null;
        this.type = null;
        this.sat_code = null;
        this.is_active = true;
        this.modified = null;
        this.created_by = null;
        this.modified_by = null;
        this.created = null;
    }

    async all() {
        let response = await axios.get("tpv/paymenttype", {
            headers: {
                user: this.user,
                company: this.id_company,
                branch: this.id_branch,
                token: this.token
            }
        });
        return response.data;
    }

    async save() {
        let response = await axios.post("tpv/paymenttype", this, {
            headers: {
                user: this.user,
                company: this.id_company,
                branch: this.id_branch,
                token: this.token
            }
        });
        return response.data;
    }
}